import { render, staticRenderFns } from "./ReasonMaster.vue?vue&type=template&id=6ed569a6"
import script from "./ReasonMaster.vue?vue&type=script&lang=js"
export * from "./ReasonMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports